export const VIEW_MODULE_REQUESTED = "VIEW_MODULE_REQUESTED";
export const VIEW_MODULE_SUCCESS = "VIEW_MODULE_SUCCESS";
export const VIEW_MODULE_FAILURE = "VIEW_MODULE_FAILURE";
